import { track } from '@bnnvara/analytics/src/track';
import uniq from 'lodash/uniq';
import { useEffect, useState } from 'react';

import useScrollPosition from './useScrollPosition';

const useSendAnalyticScrollPositions = (elementRef, elementName) => {
  const { percentageY } = useScrollPosition(elementRef);

  const scrollPoints = [25, 50, 75, 100];
  const [passedScrollPoints, setPassedScrollPoints] = useState([]);

  const passedScrollPoint = scrollPoints.reduce((acc, curr) => {
    if (percentageY >= curr) {
      return curr;
    }
    return acc;
  }, 0);

  useEffect(() => {
    if (
      passedScrollPoint > 0 &&
      !passedScrollPoints.includes(passedScrollPoint)
    ) {
      const currentPassedScrollPoints = [
        passedScrollPoint,
        ...passedScrollPoints,
      ];
      setPassedScrollPoints(uniq(currentPassedScrollPoints));
      track(elementName, 'scroll', passedScrollPoint.toString());
    }
  }, [passedScrollPoint, passedScrollPoints, elementName]);
};

export default useSendAnalyticScrollPositions;
